<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-sm
    .grid.is-middle
      .column.is-widescreen-5.is-desktop-6
        p.u-text-lg.u-mb-0 {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-desktop-10
        iframe(src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3404.1169419102794!2d31.675234515595314!3d31.43844738139672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f9e30430495077%3A0x1063562d8e487423!2z2LTYsdmD2Kkg2KjZitin2YbYp9iqIC0gQmFpYW5hdCBjb21wYW55!5e0!3m2!1sen!2seg!4v1570985594379!5m2!1sen!2seg' width='100%' height='480' frameborder='0' style='border:0;' allowfullscreen='')

  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('discoverOpportunities')" tag="h2")

    Query(
      :query="require('~/graphql/Career.gql').Careers"
      :limit="6"
      :initialValue="careers"
      :variables="({ first, after }) => ({ first, after, isPublished: true, isArchived: false })"
      v-slot="{ items }"
    )
      CareersCard(v-for="career,idx in items" :key="idx" :data="career" v-if="isBranch(career.branchObj)")

  section.u-mt-md.u-mb-md
    .grid.is-widescreen-7.is-desktop-8.is-tablet-10
      .column
        h4.u-mb-xm {{$t('ctaContent')}}
    AppLink(to="/company/franchise" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
import { Careers } from '~/graphql/Career.gql';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import CareersCard from '~/components/CareersCard';

export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    Query,
    AsymetricGrid,
    CareersCard
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Careers,
      variables: {
        first: 6,
        isPublished: true,
        isArchived: false
      }
    });
    return { careers: data.careers };
  },
  methods: {
    isBranch(branches) {
      return branches.some(b => b.name === 'Damietta');
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Damietta, Egypt",
    "pageDesc":"Visit us in our branches, meet the team and have a closer look into Baianat culture.",
    "mantra":"Damietta, Egypt",
    "mantraDesc":"Located in a coastal city, our headquarters is the place where innovation happens and the kitchen where projects kickoff. It contains +50 individuals working across different fields and sharing disruptive ideas all day long.",
    "careersCta":"See open opportunities",
    "ctaContent":"We are looking for ambitious partners from around the world to join our journey and add to our culture of innovation.",
    "cta":"Franchise with us",
    "discoverOpportunities":"Discover our open |opportunities."

  },
  "ar": {
    "pageTitle":"دمياط، مصر",
    "pageDesc":"يمكنك زيارة فروعنا والتعرف على فريقنا وإلقاء نظرة خاطفة على كل ما نقوم به وكذلك معرفة ثقافة بيانات عن قرب.",
    "mantra":"دمياط، مصر.",
    "mantraDesc":"يقع مقرنا في مدينة ساحلية، وهو المكان الذي ينطلق منه الابتكار والمطبخ الذي تؤسس بداخله المشروعات. يحتوي على أكثر من 50 فردًا يعملون في مختلف المجالات ويتبادلون الأفكار طوال اليوم.",
    "careersCta":"تعرف على الفرص المتاحة",
    "ctaContent":"نبحث عن شركاء طموحين من جميع أنحاء العالم للانضمام إلى رحلتنا وإضافة المزيد إلى ثقافة الابتكار لدينا.",
    "cta":"احصل على حق الامتياز",
    "discoverOpportunities":"اكتشف جميع |الفرص المتاحة."

  }
}
</i18n>
